import { takeLatest } from 'redux-saga/effects';

import { SET_MESSAGE, CLEAR_MESSAGE } from './actions';

/* APP FLOW - User */
function* setMessage(message) {
  yield takeLatest(SET_MESSAGE, message);
}

function* clearMessage() {
  yield takeLatest(CLEAR_MESSAGE);
}

export default [setMessage, clearMessage];
